module.exports = __webpack_public_path__ + "img/express-delivery-big.634d011.svg";